import { Vector2, HalfFloatType, FloatType, WebGLRenderTarget } from "three";

import Advection from "./Advection";
import ExternalForce from "./ExternalForce";
import Divergence from "./Divergence";
import Poisson from "./Poisson";
import Pressure from "./Pressure";
import Experience from "../Experience";

export default class Simulation{
    constructor(props){
        this.props = props;

        this.fbos = {
            vel_0: null,
            vel_1: null,

            // for calc next velocity with viscous
            vel_viscous0: null,
            vel_viscous1: null,

            // for calc pressure
            div: null,

            // for calc poisson equation
            pressure_0: null,
            pressure_1: null,
        };

        this.options = {
            iterations_poisson: 8, //32
            iterations_viscous: 8, //32
            mouse_force: 20,
            resolution: .5,
            cursor_size: 120,
            viscous: 15,
            dt: 0.024,//0.014,
            isViscous: false,
        };

        this.experience = Experience.getInstance();
        this.sizes = this.experience.sizes;
        this.fboSize = new Vector2();
        this.cellScale = new Vector2();
        this.boundarySpace = new Vector2();

        this.init();
    }

    init(){
        this.calcSize();
        this.createAllFBO();
        this.createShaderPass();
    }

    createAllFBO(){
        const type = ( /(iPad|iPhone|iPod)/g.test( navigator.userAgent ) ) ? HalfFloatType : FloatType;

        for(let key in this.fbos){
            this.fbos[key] = new WebGLRenderTarget(
                this.fboSize.x,
                this.fboSize.y,
                {
                    type: type
                }
            )
        }
    }

    createShaderPass(){
        this.advection = new Advection({
            cellScale: this.cellScale,
            fboSize: this.fboSize,
            dt: this.options.dt,
            src: this.fbos.vel_0,
            dst: this.fbos.vel_1
        });

        this.externalForce = new ExternalForce({
            cellScale: this.cellScale,
            cursor_size: this.options.cursor_size,
            dst: this.fbos.vel_1,
        });

        this.divergence = new Divergence({
            cellScale: this.cellScale,
            boundarySpace: this.boundarySpace,
            src: this.fbos.vel_viscous0,
            dst: this.fbos.div,
            dt: this.options.dt,
        });

        this.poisson = new Poisson({
            cellScale: this.cellScale,
            boundarySpace: this.boundarySpace,
            src: this.fbos.div,
            dst: this.fbos.pressure_1,
            dst_: this.fbos.pressure_0,
        });

        this.pressure = new Pressure({
            cellScale: this.cellScale,
            boundarySpace: this.boundarySpace,
            src_p: this.fbos.pressure_0,
            src_v: this.fbos.vel_viscous0,
            dst: this.fbos.vel_0,
            dt: this.options.dt,
        });
    }

    calcSize(){
        const width = Math.round(this.options.resolution * this.sizes.hero.width);
        const height = Math.round(this.options.resolution * this.sizes.hero.height);
        // const width = Math.pow(2, Math.ceil(Math.log2(this.sizes.hero.width * this.options.resolution)));
        // const height = Math.pow(2, Math.ceil(Math.log2(this.sizes.hero.height * this.options.resolution)));
        const px_x = 1.0 / width;
        const px_y = 1.0 / height;

        this.cellScale.set(px_x, px_y);
        this.fboSize.set(width, height);
    }

    resize(){
        this.calcSize();

        for(let key in this.fbos){
            this.fbos[key].setSize(this.fboSize.x, this.fboSize.y);
        }
    }


    update(){

        this.boundarySpace.copy(this.cellScale);

        this.advection.update(this.options);

        this.externalForce.update({
            cursor_size: this.options.cursor_size,
            mouse_force: this.options.mouse_force,
            cellScale: this.cellScale
        });

        let vel = this.fbos.vel_1;

        this.divergence.update({vel});

        const pressure = this.poisson.update({
            iterations: this.options.iterations_poisson,
        });

        this.pressure.update({ vel , pressure});
    }

    destroy() {
        for (let key in this.fbos) {
            if (this.fbos[key]) {
                this.fbos[key].dispose();
                this.fbos[key] = null;
            }
        }

        if (this.advection) {
            this.advection.destroy();
            this.advection = null;
        }
        if (this.externalForce) {
            this.externalForce.destroy();
            this.externalForce = null;
        }
        if (this.divergence) {
            this.divergence.destroy();
            this.divergence = null;
        }
        if (this.poisson) {
            this.poisson.destroy();
            this.poisson = null;
        }
        if (this.pressure) {
            this.pressure.destroy();
            this.pressure = null;
        }

        this.props = null;
        this.experience = null;
        this.sizes = null;
        this.fboSize = null;
        this.cellScale = null;
        this.boundarySpace = null;

        this.options = null;
    }
}
